import Joi from '@hapi/joi';
import React from 'react';
import { CraConditionScores } from '../../../../../common/src/enums/CraConditionScores';
import { useTranslate } from '../../../mixins/translate/translate';
import { CollapsiblePanel, EditPanel, EditPanelButtons, EditPanelCell, EditPanelRow, PanelBody, Tray } from '../../elements';
import { DisplayMessage } from '../../utils/displayMessage';
import { ValidatingEditPanelSaveButton, ValidatingForm, ValidatingFormContext, ValidatingFormTextArea } from '../../validatingElements';
import { CraCondition } from './CraCondition';

export function ElementGroupVerification(props: { elementGroupName: string; surveyId: string }) {
    const translate = useTranslate();
    const [isSavedMessageVisible, setIsShowSavedMessageVisible] = React.useState(false);

    React.useEffect(() => {
        setIsShowSavedMessageVisible(false);
    }, [props.elementGroupName]);

    return (
        <Tray>
            {isSavedMessageVisible && (
                <DisplayMessage message={translate('common.saved')} messageType="saved" onClose={() => setIsShowSavedMessageVisible(false)} />
            )}
            <CollapsiblePanel
                heading={{
                    dark: true,
                    text: `${translate('cra.constructionRiskAssessment')}: ${translate(`elementGroupName.${props.elementGroupName}`)}`,
                }}
            >
                <PanelBody isForm={true}>
                    <EditPanel>
                        <ValidatingForm
                            schema={Joi.object()}
                            itemUrl={`/api/surveys/${props.surveyId}/elementGroups/${props.elementGroupName}`}
                            id={props.elementGroupName}
                            onSubmitted={() => setIsShowSavedMessageVisible(true)}
                        >
                            <EditPanelRow>
                                <EditPanelCell rowCount={8}>{translate('cra.craMaxInspectionScore')}</EditPanelCell>
                                <EditPanelCell rowCount={4}>
                                    <ValidatingFormContext.Consumer>
                                        {(state) => (
                                            <span>
                                                <CraCondition conditionScore={state.item.craMaxInspectionScore as CraConditionScores} />
                                                &nbsp;({state.item.craMaxInspectionScore})
                                            </span>
                                        )}
                                    </ValidatingFormContext.Consumer>
                                </EditPanelCell>
                            </EditPanelRow>
                            <EditPanelRow>
                                <ValidatingFormTextArea name="inspectionRemarks" placeholder={translate('common.remarks')} />
                            </EditPanelRow>
                            <EditPanelButtons>
                                <ValidatingEditPanelSaveButton small={true} />
                            </EditPanelButtons>
                        </ValidatingForm>
                    </EditPanel>
                </PanelBody>
            </CollapsiblePanel>
        </Tray>
    );
}
